import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Dialog from './Dialog';
import {
  DOC_FORMAT_CONFIG_VALUES,
  INTERNAL_API_SERVER_ERROR,
  MAX_OPEN_FILE_SIZE,
  MAX_SHARE_LINK_PERIOD_EDU,
  PRODUCT_TYPE,
  PRODUCT_TYPE_WHEN_ROUTING,
  STARTMODE_WHEN_ROUTING,
  USE_REACT_ROUTER
} from '../../define/global';
import LocalStorageManager from '../../utils/LocalStorageManager';
import { MAX_SHARE_LINK_PERIOD, MAX_SHARE_LINK_COUNT, BUTTON_UNIKEY } from '../../define/global';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../store/modules/dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { showToast } from '../../store/modules/toast';
import { pushFile } from '../../utils/s3Connect';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { useDocInfoSliceSelector } from '../../store/modules/docInfo';
import copy from 'copy-to-clipboard';
import spinnerImage from '../../img/white_spinner.png';
import Button from '../common/Button';
import iconLink from '../../img/ico_link.png';
import iconLink2X from '../../img/ico_link@2x.png';
import { Trans, useTranslation } from 'react-i18next';
import FixedAD, { FIXED_AD_ID } from '../common/FixedAD';
import ga from '../../utils/gaConnect';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { genEmbedCode, getPOClientDownloadURL, isDevicePC } from '../../utils/util';
import { generateShortLinkByDirect } from '../../utils/InnerApi';
import { cLog } from '../../utils/consoleLog';
import ShareDocumentLinkDialogMobile from './mobile/ShareDocumentLinkDialogMobile';
import { hideConfirm, showConfirm } from '../../store/modules/confirm';

const play = keyframes`
100% {background-position : -832px;}
`;

export const ProgressSpinner = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-image: url(${spinnerImage});
  animation: ${play} 0.7s steps(26) infinite;
  //transform: translate(0, -32px);
`;

const DialogBody = styled.div`
  width: 500px;
  /* height: 442px; */
  padding-top: 18px;
`;

const DescriptionBody = styled.div`
  /* height: 114px; */
  margin: 16px 19px 6px 0px;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #96999c;
`;

const DescriptionBodyList = styled.ul`
  padding-left: 33px;
`;
const DescriptionBodyListItem = styled.li``;
const DescriptionBodyListItemText = styled.span`
  position: relative;
  left: -7px;
`;

const SharLinkWrapper = styled.div`
  height: 40px;
  margin: 0px 16px 5px;
  background-color: #ffffff;
  display: flex;
  box-sizing: border-box;
`;

const PrevShareLinkTitle = styled.div`
  height: 19px;
  margin: 5px 20px 11px 16px;
  padding: 13px 0 0 0;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const PrevShareLinkListArea = styled.div`
  height: 107px;
  margin: 0px 16px 16px 16px;
  padding-top: 7px;
  border-radius: 2px;
  background-color: #f5f5f5;
  box-sizing: border-box;
`;

const ShareLinkInputText = styled.div`
  //width: 369px;
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5e6266;
  //border-radius: 2px;
  border: solid 1px #b1b6bb;
  box-sizing: border-box;
  padding-left: 12px;
  overflow-x: hidden;
  padding: 8px 20px 8px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;

  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-right: none;

  ${({ disable }) => {
    return (
      disable &&
      css`
        color: #c1c1c1;
        cursor: not-allowed;
      `
    );
  }};

  ${({ normal }) => {
    return (
      normal &&
      css`
        font-weight: 400;
      `
    );
  }};
`;

const InstallHyperlinkWrapper = styled.div`
  height: 19px;
  margin: 6px 0px 16px 26px;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1d7ff9;
`;

const InstallHyperlink = styled.a``;

const AdBox = styled.div`
  width: 468px;
  height: 60px;
  margin: 0px 16px 16px 16px;
`;

const ShareLinkItemWrapper = styled.div`
  height: 31px;
  display: flex;
  padding: 0 12px 0 11px;
  align-items: center;
`;

const ShareLinkItemTarget = styled.div`
  //max-width: 356px;
  display: flex;
  flex: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

const ShareLinkItemTargetText = styled.a`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1d7ff9;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const NoLinkMessageWrapper = styled.span`
  display: flex;

  align-items: center;
  flex-direction: column;
`;

const NoLinkMessage = styled.span`
  margin: 9px 0 0;
  font-weight: 400;
  font-size: 13px;
  color: #96999c;
`;

const genEllipsis = (str, max) => {
  if (str.length > max && max > 0) {
    return `...${str.slice(-max)}`;
  } else {
    return str;
  }
};

export const MAX_STRING_LENGTH = 43;

export const getShareLinkPeriod = (productType) =>
  productType === PRODUCT_TYPE.WITH_WHALE_SPACE ? MAX_SHARE_LINK_PERIOD_EDU : MAX_SHARE_LINK_PERIOD;

function ShareDocumentLinkDialog({ isShow }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const pOWebofficeSDK = usePOWebofficeSDKState();
  const docInfo = useDocInfoSliceSelector();
  const onClickCloseBtn = () => dispatch(closeDialog());
  const [shareLinkState, setShareLinkState] = useState({
    isGeneratedShareLink: false,
    isInProcessGenerating: false,
    shareLinkURL: ''
  });

  const appData = useAppDataSliceSelector();
  const targetHref = getPOClientDownloadURL({ appData, lang: i18n.language });
  const isPCView = isDevicePC(appData.deviceType);

  const storageManager = useRef(null);
  const [shareLinks, setShareLinks] = useState([]);
  const isClickKakao = useRef(false);

  //const storageManager = new LocalStorageManager();
  //let shareLinks = null;
  //if (storageManager.storageAvailable()) {
  //  shareLinks = storageManager.getItem();
  //}
  // TODO : need to add new share link
  // storageManager.addItem(newShareLink);
  const [tempShareLinkText, setTempShareLinkText] = useState(
    i18n.t('ShareDocumentLinkDialog.CreateLink')
  );
  const copySuccessText = i18n.t('ShareDocumentLinkDialog.CopyLink');

  const executeTime = useRef(0);

  useEffect(() => {
    storageManager.current = new LocalStorageManager();
    if (storageManager.current.storageAvailable()) {
      setShareLinks(storageManager.current.getItem());
    }

    createKaKao();
  }, []);

  const createKaKao = () => {
    if (window.Kakao) {
      const kakao = window.Kakao;
      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
    }
  };

  const onCopy = (e) => {
    dispatch(showToast({ msg: copySuccessText }));
  };

  const openShareWithKakao = (shareLink) => {
    isClickKakao.current = false;
    try {
      window.Kakao.Link.sendScrap({
        requestUrl: shareLink,
        installTalk: true,
        fail: function () {
          dispatch(showToast({ msg: i18n.t('ShareDocumentLinkDialog.FailConnectKakao') }));
        }
      });
    } catch (err) {
      dispatch(showToast({ msg: i18n.t('ShareDocumentLinkDialog.FailConnectKakao') }));
    }
  };

  const genShareLink = () => {
    if (shareLinkState.isInProcessGenerating === true) return;
    const start = new Date();
    setShareLinkState((state) => ({ ...state, isInProcessGenerating: true }));
    setTempShareLinkText(i18n.t('ShareDocumentLinkDialog.CreatingLink'));

    pOWebofficeSDK.poInstance.handle.saveDocument().then((docFile) => {
      ga.event({ category: '사용지표', action: '공유 문서 크기', value: docFile.blob.size });
      pushFile(docInfo.fileName, docFile)
        .then(async ({ key, su }) => {
          setShareLinkState((state) => ({ ...state, isGeneratedShareLink: true }));
          let shareURL = `${window.location.origin}/?shareID=${key}`;
          if (su === false) shareURL += `&su=${su}`;

          if (USE_REACT_ROUTER) {
            const productTypeAsParams =
              appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE
                ? PRODUCT_TYPE_WHEN_ROUTING.WHALE_SPACE
                : PRODUCT_TYPE_WHEN_ROUTING.DEV;

            shareURL = [
              window.location.origin,
              productTypeAsParams,
              DOC_FORMAT_CONFIG_VALUES.sdk.documnetType,
              STARTMODE_WHEN_ROUTING.SHARE_VIEW,
              key
            ].join('/');
          }

          setTempShareLinkText(shareURL);
          storageManager.current.addItem(shareURL);
          if (storageManager.current.storageAvailable()) {
            setShareLinks(storageManager.current.getItem());
          }
          executeTime.current = new Date() - start;

          if (isPCView) {
            if (isClickKakao.current === false) {
              const copyResult = copy(shareURL);
              if (copyResult) {
                onCopy();
              }
            }
          }

          if (isClickKakao.current === true) {
            openShareWithKakao(shareURL);
          }
        })
        .catch((err) => {
          setShareLinkState((state) => ({ ...state, isInProcessGenerating: false }));
          setTempShareLinkText(i18n.t('ShareDocumentLinkDialog.CreateLink'));

          if (
            err.response &&
            err.response.data &&
            err.response.data.error &&
            err.response.data.error === INTERNAL_API_SERVER_ERROR.FILE_TOO_LARGE
          ) {
            dispatch(
              showToast({
                msg: i18n.t('ShareDocumentLinkDialog.LimitFileSize', {
                  MAX_OPEN_FILE_SIZE
                })
              })
            );
          } else {
            dispatch(showToast({ msg: i18n.t('ShareDocumentLinkDialog.FailLink') }));
          }
        });
    });
  };

  const onClickPOHyperLink = () => {
    ga.event({ category: '이동', action: 'PO바로가기', label: '공유메뉴' });
  };

  const onClickShareKakao = () => {
    ga.event({ category: '공유', action: '카카오톡 공유하기' });
    isClickKakao.current = true;
    if (shareLinkState.isGeneratedShareLink === true) {
      openShareWithKakao(tempShareLinkText);
    } else {
      genShareLink();
    }
  };

  const copyEmbedCode = (code) => {
    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      try {
        textarea.value = code;

        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, 9999); // 추가

        if (document.execCommand('copy')) {
          resolve();
        } else reject();

        document.body.removeChild(textarea);
      } catch (error) {
        document.body.removeChild(textarea);
        reject();
      }
    });
  };

  const onClickGenCode = (link) => {
    const genCode = genEmbedCode(link);
    dispatch(
      showConfirm({
        msg: genCode,
        showCloseBtn: true,
        btn: {
          confirm: {
            text: i18n.t('ShareDocumentLinkDialog.Copy'),
            callback: () => {
              copyEmbedCode(genCode)
                .then(() =>
                  dispatch(showToast({ msg: i18n.t('ShareDocumentLinkDialog.CopyCode') }))
                )
                .catch(() =>
                  dispatch(showToast({ msg: i18n.t('ShareDocumentLinkDialog.FailCopyCode') }))
                );
            }
          },
          cancel: {
            text: i18n.t('Common.Cancel'),
            callback: () => {
              dispatch(hideConfirm());
            }
          }
        }
      })
    );
  };

  return (
    <>
      {isPCView === true ? (
        <Dialog
          title={t('ShareDocumentLinkDialog.ShareLink')}
          showCloseBtn
          showTitleSeperateLine
          onClickCloseBtn={onClickCloseBtn}
          isShow={isShow}>
          <DialogBody>
            <SharLinkWrapper>
              <ShareLinkInputText
                disable={!shareLinkState.isGeneratedShareLink}
                normal={!shareLinkState.isGeneratedShareLink}>
                {genEllipsis(tempShareLinkText, MAX_STRING_LENGTH)}
              </ShareLinkInputText>
              {shareLinkState.isGeneratedShareLink ? (
                <CopyToClipboard onCopy={onCopy} text={tempShareLinkText}>
                  <Button
                    cssExt={css`
                      min-width: 100px;
                      border-top-left-radius: 0px;
                      border-bottom-left-radius: 0px;
                      background: #f4f4f4;
                      font-weight: 700;
                      color: #2f3133;
                    `}
                    uniKey={BUTTON_UNIKEY.SHARED_LINK_COPY_NEW_BTN}
                    onClick={(e) => {
                      e.target.blur();
                    }}>
                    {t('ShareDocumentLinkDialog.Copy')}
                  </Button>
                </CopyToClipboard>
              ) : (
                <Button
                  cssExt={css`
                    min-width: 100px;
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  `}
                  primary
                  onClick={genShareLink}
                  uniKey={BUTTON_UNIKEY.SHARED_LINK_GEN_BTN}
                  executeTime={executeTime.current}>
                  {shareLinkState.isInProcessGenerating ? (
                    <ProgressSpinner width="32px" height="32px" />
                  ) : (
                    t('ShareDocumentLinkDialog.Create')
                  )}
                </Button>
              )}
            </SharLinkWrapper>
            <PrevShareLinkTitle>
              {t('ShareDocumentLinkDialog.ShareLinkPeriodCount', {
                period: getShareLinkPeriod(appData.productType),
                count: MAX_SHARE_LINK_COUNT
              })}
            </PrevShareLinkTitle>
            <PrevShareLinkListArea>
              {shareLinks && shareLinks.length > 0 ? (
                shareLinks.map((link, index) =>
                  index < MAX_SHARE_LINK_COUNT ? (
                    <ShareLinkItemWrapper key={index}>
                      <ShareLinkItemTarget>
                        <ShareLinkItemTargetText href={link} target="_blank">
                          {genEllipsis(link, MAX_STRING_LENGTH)}
                        </ShareLinkItemTargetText>
                      </ShareLinkItemTarget>
                      <CopyToClipboard onCopy={onCopy} text={link}>
                        <Button
                          onClick={(e) => {
                            e.target.blur();
                          }}
                          cssExt={css`
                            min-width: 89px;
                            background: #f5f5f5;
                            color: #2f3133;
                            margin-left: 27px;
                            padding-top: 0px;
                            padding-bottom: 1px;
                          `}
                          uniKey={BUTTON_UNIKEY.SHARED_LINK_COPY_EXIST_BTN}>
                          {t('ShareDocumentLinkDialog.Copy')}
                        </Button>
                      </CopyToClipboard>
                      {/* <Button
                        onClick={() => onClickGenCode(link)}
                        cssExt={css`
                          min-width: 65px;
                          background: #f5f5f5;
                          color: #2f3133;
                          margin-left: 5px;
                          padding-top: 0px;
                          padding-bottom: 1px;
                        `}>
                        {t('ShareDocumentLinkDialog.GenCode')}
                      </Button> */}
                    </ShareLinkItemWrapper>
                  ) : null
                )
              ) : (
                <NoLinkMessageWrapper>
                  <img
                    width="32px"
                    src={iconLink}
                    alt=""
                    srcSet={iconLink2X}
                    style={{ marginTop: '20px' }}
                  />
                  <NoLinkMessage>{t('ShareDocumentLinkDialog.NoShareLink')}</NoLinkMessage>{' '}
                </NoLinkMessageWrapper>
              )}
            </PrevShareLinkListArea>
            <DescriptionBody>
              <DescriptionBodyList>
                <DescriptionBodyListItem>
                  <DescriptionBodyListItemText>
                    {t('ShareDocumentLinkDialog.AnyoneOpenShareLink')}
                  </DescriptionBodyListItemText>
                </DescriptionBodyListItem>
                <DescriptionBodyListItem>
                  <DescriptionBodyListItemText>
                    {t('ShareDocumentLinkDialog.ShareLinkPeriod', {
                      period: getShareLinkPeriod(appData.productType)
                    })}
                  </DescriptionBodyListItemText>
                </DescriptionBodyListItem>
                <DescriptionBodyListItem>
                  <DescriptionBodyListItemText>
                    <Trans i18nKey="ShareDocumentLinkDialog.NotSavedAfterShare"></Trans>
                  </DescriptionBodyListItemText>
                </DescriptionBodyListItem>
                <DescriptionBodyListItem>
                  <DescriptionBodyListItemText>
                    <Trans i18nKey="ShareDocumentLinkDialog.Discription"></Trans>
                  </DescriptionBodyListItemText>
                </DescriptionBodyListItem>
              </DescriptionBodyList>
            </DescriptionBody>
            <InstallHyperlinkWrapper>
              <InstallHyperlink
                href={targetHref}
                target="_blank"
                rel="noreferrer"
                onClick={onClickPOHyperLink}>
                {t('ShareDocumentLinkDialog.InstallPC')}
              </InstallHyperlink>
            </InstallHyperlinkWrapper>
            <AdBox>
              <FixedAD id={FIXED_AD_ID.IN_SHARELINK_DIALOG} />
            </AdBox>
          </DialogBody>
        </Dialog>
      ) : (
        <ShareDocumentLinkDialogMobile
          isShow={isShow}
          onClickCloseBtn={onClickCloseBtn}
          genShareLink={genShareLink}
          shareLinkState={shareLinkState}
          tempShareLinkText={tempShareLinkText}
          genEllipsis={genEllipsis}
          onCopy={onCopy}
          executeTime={executeTime}
          onClickShareKakao={onClickShareKakao}
        />
      )}
    </>
  );
}

export default ShareDocumentLinkDialog;
